import type { FC, ImgHTMLAttributes } from "react";
import styles from "./CardPride.module.scss";
import { Link } from "react-router-dom";

interface CardPridesProps {
    title: string;
    imageAttributes: ImgHTMLAttributes<HTMLImageElement>;
    to: string;
}

export const CardPride: FC<CardPridesProps> = ({ title, imageAttributes, to }) => (
    <Link to={to} className={styles.wrapper}>
        <h4 className={styles.title}>{title}</h4>
        <img {...imageAttributes} alt={title} className={styles.img} />
    </Link>
);
